import { useState } from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { questionsData } from "../../data/data";
// import faqImg from "../../assets/svg/Artboard-3.svg";
import "./Question.scss";

const Question = () => {
  const [showAnswers, setShowAnswers] = useState(
    Array(questionsData.length).fill(false)
  );
  const toggleAnswer = (index) => {
    setShowAnswers((prevShowAnswers) => {
      const newShowAnswers = prevShowAnswers.map((value, idx) => {
        return idx === index ? !value : false;
      });
      return newShowAnswers;
    });
  };

  return (
    <section className="question">
      <article className="question__container container">
        <div className="section__header">
          <h1 className="section__title">GOT QUESTIONS</h1>
          <p className="section__title-center">
            What do you wanna know? We&apos;ve Got answers{" "}
          </p>
        </div>
        <div className="question__container-content">
          {/*  */}
          <div className="question__container-content--right">
            {questionsData.map((question, index) => {
              const { id, title, info } = question;
              const isOpen = showAnswers[index];
              return (
                <div
                  key={id}
                  className="question__faq"
                  onClick={() => toggleAnswer(index)}
                  data-aos="fade-down"
                  data-aos-easing="ease"
                >
                  <header className="question__header">
                    <h4 className={isOpen ? "open-question" : ""}>{title}</h4>
                    <button className="btn">
                      {showAnswers[index] ? <FaChevronUp /> : <FaChevronDown />}
                    </button>
                  </header>
                  {/* Show the answer only if showAnswers[index] is true */}
                  {showAnswers[index] && <p>{info}</p>}
                </div>
              );
            })}
          </div>
        </div>
      </article>
    </section>
  );
};

export default Question;
